module.exports = __webpack_public_path__ + "6c83f2be4e7735938cba6ee3b1315a44.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/arrow-repeat.png
// module id = 48
// module chunks = 0